import React, { FC } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from './Impressum.module.scss';
import Spinner from '../../../shared/Spinner/Spinner';
import { useStaticPageQuery } from 'src/hooks/query';

const ImpressumPage: FC = () => {
  const { html, isLoading } = useStaticPageQuery('impressum');

  if (isLoading) {
    return (
      <Container>
        <Spinner />
      </Container>
    );
  }

  return (
    <Container>
      <Row></Row>
      <Row>
        <Col sm={12}>
          <div className={styles.impressumContent} dangerouslySetInnerHTML={html} />
        </Col>
      </Row>
    </Container>
  );
};

export default ImpressumPage;
